import { isValidPositiveNumber } from "./numbers.helpers";

export const isIncompleteHubPairingBooking = (booking: {
  rideMainId?: number | null;
  ridePersonalId?: number | null;
}): boolean => {
  const hasMain = isValidPositiveNumber(booking.rideMainId);
  const hasPersonal = isValidPositiveNumber(booking.ridePersonalId);
  return (hasMain && !hasPersonal) || (!hasMain && hasPersonal);
};
